export const FAQ_ACCESSED_KEY = "faqAccessed";
